import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule, InputTextModule, TooltipModule, DataTableModule, DragDropModule } from 'primeng/primeng';
import { TranslateModule } from '@ngx-translate/core';

import { DragAndDropComponent } from './drag-and-drop.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    ButtonModule,
    InputTextModule,
    TooltipModule,
    DataTableModule,
    DragDropModule
  ],
  declarations: [
    DragAndDropComponent
  ],
  exports: [
    DragAndDropComponent
  ]
})
export class DragAndDropModule { }



// WEBPACK FOOTER //
// /dist/src/app/shared/drag-and-drop/drag-and-drop.module.ts